import Constants from 'Components/ContractGenerator/shared/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import Icon from 'ViatoUi/Shared/DataDisplay/Icon';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import Button from 'ViatoUi/Web/FormElements/Buttons/Button';

import PriceSummary from '../PriceSummary';
import ButtonStep2 from './ButtonStep2';
import styles from './Footer.module.scss';

const Footer = () => {
	const { t } = useTranslation('contractGenerator');
	const dispatch = useDispatch();

	const windowWidth = useSelector(contractGeneratorSelectors.getWindowWidth);
	const activeStep = useSelector(contractGeneratorSelectors.getActiveStep);

	const getButtons = () => {
		switch (activeStep) {
			case Constants.STEPS.STEP3:
				return (
					<>
						<Button type='slate' onClick={() => dispatch(contractGeneratorOperations.setActiveStep(Constants.STEPS.STEP2))}>
							{windowWidth > 940 || windowWidth <= 690 ? (
								t('app.userActions.back')
							) : (
								<Icon color='bright' icon='fa-angle-left' iconWeight='far' size='xl' />
							)}
						</Button>
						<Spacer width='m' />
						<Button type='secondary' onClick={() => dispatch(contractGeneratorOperations.setActiveStep(Constants.STEPS.STEP4))}>
							{t('app.userActions.toBooking')}
						</Button>
					</>
				);

			default:
				return <ButtonStep2 />;
		}
	};

	return (
		<FlexBox alignItems='center' className={styles.footer} justifyContent='center'>
			<FlexBox alignItems='center' className={styles.inner} justifyContent='space-between'>
				{windowWidth > 690 ? (
					<>
						<PriceSummary headline={<strong>{t('layouts.footer.totalPrice')}:</strong>} />
						<FlexBox alignItems='center'>{getButtons()}</FlexBox>
					</>
				) : (
					<>{getButtons()}</>
				)}
			</FlexBox>
		</FlexBox>
	);
};

export default Footer;
